module.exports = __webpack_public_path__ + "media/packs/assets/no-image-3eacb191d0f8e51da19d1cd9efba8ca3.png";